// 合作伙伴
<template>
  <div class="partner">
    <div class="title">合作伙伴</div>
    <div class="content">
      <div
        class="institution"
        v-for="(item, index) in partner"
        :key="`institution-item${index + 1}`"
      >
        <div class="institution-type">{{ item.name }}</div>
        <div class="partner-list">
          <img
            class="partner-item"
            v-for="(it, i) in item.src"
            :key="`partner-item${i + 1}`"
            :src="it"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "partner",
  data() {
    return {
      partner: [
        {
          name: "社会机构和高校",
          src: [
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zf_01_zgcy.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zf_02_zgcdsj.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zf_03_shdsj.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zf_04_szsdsj.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zf_05_jzbkl.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zf_06_mxg.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zf_07_stf.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zf_knjml.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zf_09_qhdx.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zf_10_bjdx.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zf_11_zjdx.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zf_12_hfdx.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zf_13_fddx.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zf_14_jtdx.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zf_15_jxcj.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zf_16_jtlg.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zf_17_tylg.png"
          ]
        },
        {
          name: "投资机构",
          src: [
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/tzjg_01_hszb.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/tzjg_gmkg.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/tzjg_03_shgt.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/tzjg_shkc.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/tzjg_zjkt.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/tzjg_szzb.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/tzjg_07_yjzb.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/tzjg_qdsf.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/tzjg_09_lhgf.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/tzjg_10_mlzb.png"
          ]
        },
        {
          name: "知名企业",
          src: [
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zmqy_bwjt.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zmqy_bgjt.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zmqy_xgjt.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zmqy_mgjt.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zmqy_jgjt.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zmqy_pgjt.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zmqy_xxjt.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/tzqy_08_zgty.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zmqy_gjdw.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/tzqy_10_jcjt.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zmqy_zgrs.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zmqy_fwbx.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/tzqy_16_zgdx.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/tzqy_17_zgyd.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/tzqy_18_zgjsyh.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/tzqy_19_zgjtyh.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zmqy_xyyh.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zmqy_hsyy.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zmqy_zgykw.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zmqy_blueair.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/tzqy_26_lhlh.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zmqy_OPPO.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zmqy_wph.png",
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/unidt/img/zmqy_ln.png"
          ]
        }
      ]
    };
  }
};
</script>
<style lang="less" scoped>
.partner {
  width: 100%;
  padding: 96px 0px;
  .title {
    width: calc(100% - 64px);
    height: 174px;
    background: url("../../../static/img/other/legalnotice_bg.png") no-repeat 0
      0 / 100%;
    overflow: hidden;
    font-size: 44px;
    color: #08204d;
    line-height: 174px;
    padding-left: 64px;
  }
  .content {
    padding: 40px 64px;
    .institution {
      margin-bottom: 52px;
      .institution-type {
        font-size: 32px;
        color: #08204d;
        line-height: 44px;
      }
      .partner-list {
        margin-top: 24px;
        display: flex;
        flex-wrap: wrap;
        .partner-item {
          width: 198px;
          height: 132px;
          margin: 0 calc((100% - 594px) / 3) 12px 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/otherfunction/partner.vue